module.exports = __webpack_public_path__ + "img/program-talk_1.10b37636.jpg";